import {
	Checkbox,
	FormControlLabel,
	FormGroup,
	MenuItem,
	TextField,
} from "@mui/material";
import React, { useState, useContext } from "react";
import { Upload } from "tabler-icons-react";
import profile from "../assets/profile.jpg";
import counties from "../assets/counties.json";
import { MenuContext } from "../context/menuContext";
import TextInput from "../utils/TextInput";

function NewUser() {
	const [county, setCounty] = useState("");
	const { mobileMenu } = useContext(MenuContext);

	const handleChange = (event) => {
		setCounty(event.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log("submitted");
	};

	return (
		<div
			className={
				mobileMenu
					? "absolute md:left-64 md:top-0 md:w-[calc(100%-16rem)] py-3 h-screen bg-slate-50 dark:bg-darkbg"
					: "absolute md:left-[13rem] lg:left-64 top-[3rem] md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-screen bg-slate-50 dark:bg-darkbg"
			}>
			<h1 className="mb-3 py-1 px-5 text-slate-500 dark:text-darktext uppercase font-semibold border-b border-b-slate-100 dark:border-b-darkborder">
				New User
			</h1>
			<div className="flex flex-col lg:flex-row justify-center md:justify-between space-y-5 lg:space-x-5 px-5 pb-5">
				<div className="flex flex-col lg:w-1/4">
					<img
						src={profile}
						alt="profile"
						className="rounded-full object-cover h-28 w-28 mb-2 mx-auto"
					/>
					<div className="bg-white dark:bg-darkbg border border-slate-500 dark:border-darkborder border-dashed rounded-md px-2 pt-2 pb-10">
						<label className="flex flex-col items-center">
							<Upload size={60} className="" />
							<input
								type="file"
								className="block w-full text-sm text-slate-500 dark:text-darktext file:hidden file-text-sm opacity-0"
								accept=".pdf"
							/>
							<span className="text-xl font-semibold">Upload image</span>
							<p className="text-sm text-slate-500 dark:text-darktext text-center mt-3">
								Click or drag n' drop to upload your profile picture.Only .jpg
								and .png files are allowed.
							</p>
						</label>
					</div>
				</div>
				<div className="flex flex-col grow bg-white dark:bg-darkbg border border-slate-200 dark:border-darkborder rounded-md px-4">
					<h1 className="text-slate-500 dark:text-darktext text-lg font-semibold mt-3">
						User details
					</h1>
					<form
						onSubmit={handleSubmit}
						className=" w-full grid grid-cols-1 lg:grid-cols-2 gap-y-4 lg:gap-x-4 md:gap-y-14 justify-between pb-10 pt-2">
						<TextInput labelText="Username" />
						<TextInput labelText="Email" type="email" />
						<TextInput labelText="First name" />
						<TextInput labelText="Middle name" />
						<TextInput labelText="Last name" />
						<TextInput labelText="Date of birth" />
						<TextInput labelText="Secondary school" />
						<TextInput
							select
							value={county}
							onChange={handleChange}
							helperText="Please select your county"
							labelText="County">
							{counties.map((county) => (
								<MenuItem key={county.name} value={county.name}>
									{county.name}
								</MenuItem>
							))}
						</TextInput>
						<TextInput labelText="Password" type="password" />
						<TextInput labelText="Confrim password" type="password" />
						<FormGroup className="text-slate-500 dark:text-darktext">
							<FormControlLabel
								control={<Checkbox />}
								label="Administrator"
								size="small"
							/>
						</FormGroup>
						<button className="bg-sky-100 dark:bg-darkbtn lg:col-start-2 lg:row-start-6 py-1 text-slate-600 dark:text-darktext text-lg font-medium rounded-md hover:bg-sky-200 hover:dark:bg-darkbtnhover transition-all duration-150 ease-in-out">
							Send
						</button>
					</form>
				</div>
			</div>
		</div>
	);
}

export default NewUser;
